module.exports = __webpack_public_path__ + "img/66.aa9c43e4.png";